import { useGeneralStore } from "./store/general/general.store";
import i18n from "./i18n";
import dayjs from "dayjs";
import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "@clerk/react";
import { Routes } from "./router/routes";
import { Initialize } from "./pages/initialize/initialize";

export default function App() {
    const { isLoaded, isSignedIn } = useAuth();
    const locale = useGeneralStore((state) => state.currentLocale);
    const location = useLocation();

    useEffect(() => {
        void i18n.changeLanguage(locale);
        dayjs.locale(locale);
    }, [locale]);

    if (!isLoaded) return <Initialize />;
    if (!isSignedIn) {
        const redirectUrl = location.pathname + location.search + location.hash;
        return (
            <Navigate
                to={`/${Routes.Auth}?redirect_url=${encodeURIComponent(redirectUrl)}`}
                replace
            />
        );
    }
    return <Outlet />;
}
